export const WIDGET_TRAINING_LIST_TYPE = 'learning-training-list';

export const DATA_SCOPE = 'widget-training-list';
